const HEADER_ICON_SIZE = 20;
const ATTACHMENT_PREVIEW_ICON_SIZE = 16;

export { HEADER_ICON_SIZE, ATTACHMENT_PREVIEW_ICON_SIZE };
